class SequentialTaskQueue {
  constructor() {
    this.queue = [];
    this.isExecuting = false;
  }

  enqueue(func) {
    return new Promise((resolve, reject) => {
      this.queue.push({ func, resolve, reject });
      this.#executeNext();
    });
  }

  async #executeNext() {
    if (this.isExecuting || !this.queue.length) {
      return;
    }

    const { func, resolve, reject } = this.queue.shift();

    try {
      this.isExecuting = true;
      const result = await func();
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      this.isExecuting = false;
      this.#executeNext();
    }
  }
}

// eslint-disable-next-line import/prefer-default-export
export const sequentialTaskQueue = new SequentialTaskQueue();
